import { z } from "zod"
import { baseResponseSchema, paginatedResponseSchema } from "./shared"

export const chatParticipantSchema = z.object({
  _id: z.string().optional(),
  name: z.string().optional(),
  image: z.string().optional(),
  email: z.string().optional(),
  location: z.string().optional(),
})

export const chatLastMessageSchema = z.object({
  content: z.string().optional(),
  senderRole: z.string().optional(),
  sentAt: z.string().optional(),
  sender: chatParticipantSchema.optional(),
})

export const conversationSchema = z.object({
  _id: z.string(),
  business: chatParticipantSchema.optional(),
  customer: chatParticipantSchema.optional(),
  lastMessage: chatLastMessageSchema.optional(),
  lastActivity: z.string().optional(),
  customerUnreadCount: z.number().optional(),
  businessUnreadCount: z.number().optional(),
  status: z.string().optional(),
})

export const messageSchema = z.object({
  _id: z.string(),
  conversation: z.union([z.string(), z.object({ _id: z.string().optional() })]).optional(),
  sender: chatParticipantSchema.optional(),
  senderRole: z.string().optional(),
  content: z.string().optional(),
  readBy: z.array(z.union([z.string(), z.object({ _id: z.string().optional() })])).optional(),
  createdAt: z.string().optional(),
})

export const conversationsListResponseSchema = baseResponseSchema.extend({
  data: z.array(conversationSchema),
  page: z.number().optional(),
  pageSize: z.number().optional(),
  totalPages: z.number().optional(),
  totalItems: z.number().optional(),
  unreadCount: z.number().optional(),
})

export const messagesListResponseSchema = paginatedResponseSchema(messageSchema)

export type ConversationSchema = z.infer<typeof conversationSchema>
export type MessageSchema = z.infer<typeof messageSchema>
